import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { SimpleConsentIcon } from './ConsentIcon'
import { UserConsentState } from './model'
import './ConsentStateDropdown.scss'

type ConsentStateOption = {
  value: UserConsentState
  label: string
  className: string
}

const consentStateOptions: ConsentStateOption[] = [
  { value: UserConsentState.ACCEPTED, label: 'Accepted', className: 'zocks-text-success-200' },
  { value: UserConsentState.REFUSED, label: 'Refused', className: 'zocks-text-danger-200' },
  { value: UserConsentState.REVOKED, label: 'Revoked', className: 'zocks-text-warning-text' },
  { value: UserConsentState.UNKNOWN, label: 'Unknown', className: 'zocks-text-gray-600' },
]

type ConsentStateDropdownProps = {
  value: UserConsentState
  onChange: (newValue: UserConsentState) => void
}

export const ConsentStateDropdown: React.FC<ConsentStateDropdownProps> = ({ value, onChange }) => {
  return (
    <Dropdown>
      <Dropdown.Toggle as='div' bsPrefix='consent-dropdown-toggle' className='border rounded-1 p-2 d-flex align-items-center gap-2 cursor-pointer'>
        <SimpleConsentIcon consentState={value} showText />
        <i className='bi bi-chevron-expand zocks-text-gray-500' />
      </Dropdown.Toggle>
      <Dropdown.Menu className='consent-state-dropdown-menu'>
        {consentStateOptions.map((option) => (
          <Dropdown.Item key={option.value} className={`paragraph-medium ${option.className}`} onClick={() => onChange(option.value)}>
            {option.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}
